import produce from 'immer'

import {
  FETCH_FOOTER_REQUESTED,
  FETCH_FOOTER_SUCCEEDED,
  FETCH_FOOTER_FAILED,
} from './actionTypes'

export const defaultOneLinkParams = {
  pid: null,
  c: null,
  defaultAndroid: '/LCQg',
  defaultIos: '/fEOz',
  defaultUrl: 'https://sarafan.onelink.me',
  android: 'https://sarafan.onelink.me/LCQg?pid=sarafanlinks&c=default',
  ios: 'https://sarafan.onelink.me/fEOz?pid=sarafanlinks&c=default '
}

const initialState = defaultOneLinkParams
/* eslint no-param-reassign: "error" */
const commentsReducer = produce((draft = initialState, action) => {
  switch (action.type) {
    case FETCH_FOOTER_REQUESTED:
      console.log('!!!!!FETCH_FOOTER_REQUESTED', action.payload)
      const { pid, c } = action.payload
      draft.pid = pid
      draft.c = c
      draft.ios = `${initialState.defaultUrl}${initialState.defaultIos}?pid=${pid}&c=${c}`
      draft.android = `${initialState.defaultUrl}${initialState.defaultAndroid}?pid=${pid}&c=${c}`
      return draft

    case FETCH_FOOTER_SUCCEEDED:
      return draft

    case FETCH_FOOTER_FAILED:
      draft.error = action.payload.error
      draft.loading = true
      return draft

    default:
      return draft
  }
})

export default commentsReducer



// WEBPACK FOOTER //
// ./src/store/footer/reducer.js